if($('header#header').length){
    const $menuList = $('.languagesMenu__list.languagesMenu__list--language');
    if ($menuList.length) {
      $.each(languagesArray, function(index, lang) {
        var $li = `<li>
                        <a href="/action/Language/changeLanguage/?language=en" rel="nofollow" class="languagesMenu__list__link" data-languageCode="${lang.code}" data-codeLang="${lang.codeLang}">
                            <img src="/user/documents/upload/sablona-nemazat/countryFlags/${lang.code}.png" alt="${lang.name}">
                            <span class="languagesMenu__list__name">${lang.name}</span>
                        </a>
                    </li>`
        $menuList.append($li);
        $('.navigationActions .navigationActions__submenu ul[role="menu"]').last().append($li);
      });
    }

    const storedLanguageString = localStorage.getItem('selectedLanguage');
    if (storedLanguageString) {
        var langName = $('.languagesMenu__box[data-target="language"] .languagesMenu__header.languagesMenu__header--actual').text().trim()
        var storedLanguage = JSON.parse(storedLanguageString);

        if(langName === storedLanguage.name){

        }
        else{
            $('.languagesMenu__box[data-target="language"] .languagesMenu__header.languagesMenu__header--actual').html(storedLanguage.name+' <span class="caret"></span>')  
        }
      
    } else {
        console.log("Žádná data v sessionStorage nejsou.");
    }

   
}


$('html').on('click', '.languagesMenu__list.languagesMenu__list--language a', function(e){
    const clickedCode = $(this).attr('data-languageCode');
    const clickedName = $(this).text().trim();
    const clickedCodeLang = $(this).attr('data-codeLang')
    const languageObject = {
        code: clickedCode,
        name: clickedName,
        codeLang: clickedCodeLang
    };
    localStorage.setItem('selectedLanguage', JSON.stringify(languageObject));
})

$('html').on('click', '.navigationActions .navigationActions__submenu .languagesMenu__list__link', function(e){
    const clickedCode = $(this).attr('data-languageCode');
    const clickedName = $(this).text().trim();
    const clickedCodeLang = $(this).attr('data-codeLang')
    const languageObject = {
        code: clickedCode,
        name: clickedName,
        codeLang: clickedCodeLang
    };
    localStorage.setItem('selectedLanguage', JSON.stringify(languageObject));
})
